import React from 'react'
import moment from 'moment'
import img from '../../../../public/static/image-background/logo-v-02.png'
import locales from '../../../../public/static/locales/vi.json'
import { formatDateTime, useTranslation, titleTemplate, getBase64 } from '../../../../constants/helpers'
import config from '../../../../constants/config'

const Mau7 = ({ dataSeason, dataSchedules, size, id, numberRound, sponsorData, isShowSponsor }) => {
    const { t } = useTranslation()
    const width = size
    const px = size / 100
    const color = {
        first: '#00e5ff',   // Neon Cyan
        second: '#005fcc',  // Deep Blue
        third: '#4CAF50',   // Neon Green
        text: '#ffffff',
        bg: '#030816'       // Very dark blue/black
    }
    const classCustom = size < 1000 ? 'view' : 'export'

    return (
        <div id={id} className={`bg-match-mau7`} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative' }}>

            {/* Dynamic Grid Background Overlay */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0, opacity: 0.1, backgroundImage: `linear-gradient(${color.first} 1px, transparent 1px), linear-gradient(90deg, ${color.first} 1px, transparent 1px)`, backgroundSize: `${px * 4}px ${px * 4}px`, backgroundPosition: 'center center' }}></div>

            <div style={{ width: `100%`, minHeight: `calc(${width / 1.3}px - ${3.2 * px}px)`, padding: `${px * 1.5}px ${px * 1.5}px ${px * 4.2}px ${px * 1.5}px`, position: 'relative', zIndex: 1, borderRadius: `${px * 2}px`, overflow: 'hidden' }}>

                {/* Header - Glassmorphism style */}
                <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', background: `linear-gradient(90deg, rgba(0,229,255,0.05) 0%, rgba(0,95,204,0.1) 50%, rgba(0,229,255,0.05) 100%)`, borderBottom: `1px solid rgba(0, 229, 255, 0.4)`, padding: `${px * 1.5}px`, borderRadius: `${2 * px}px`, boxShadow: `0 4px 20px rgba(0, 229, 255, 0.1), inset 0 0 10px rgba(0, 229, 255, 0.05)` }}>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'center' }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 5px rgba(255,255,255,0.8))` }} />
                    </div>
                    <div style={{ flex: 6, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${3.5 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.4}px`, textShadow: `0 0 10px ${color.first}, 0 0 20px ${color.first}` }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
                        <Image src={img} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ marginTop: `${px * 3}px`, marginBottom: `${px * 3}px` }}>
                    <h1 style={{ textAlign: 'center', color: color.first, fontSize: `${4.5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 15px rgba(0,229,255,0.6)` }}>{t(titleTemplate(dataSchedules[0]?.dataGo))}</h1>
                    {t(numberRound) === numberRound && (
                        <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${2.5 * px}px`, textTransform: 'uppercase', letterSpacing: '4px', marginTop: `${px}px` }}>
                            [ {t('round')} {numberRound} ]
                        </h1>
                    )}
                    {t(numberRound) && t(numberRound) !== numberRound && (
                        <h2 style={{ textTransform: 'uppercase', margin: `${px}px auto 0`, width: 'max-content', color: color.bg, backgroundColor: color.first, padding: `${px}px ${6 * px}px`, borderRadius: `${px}px`, fontSize: `${2.8 * px}px`, fontWeight: 'bold', boxShadow: `0 0 15px ${color.first}` }}>{t(numberRound)}</h2>
                    )}
                </div>

                {/* Matches Grid */}
                <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-between', gap: `${px * 2}px`, marginTop: `${px * 3}px` }}>
                    {dataSchedules[0]?.dataGo
                        ?.filter(i => i.awayTeam.name !== 'hidden' && i.homeTeam.name !== 'hidden')
                        ?.map((i, idx) => (
                            <Item key={`${idx}${new Date()}`} data={i} px={px} classCustom={classCustom} idx={idx} width={width} color={color} />
                        ))}
                </div>

                {/* Sponsors */}
                {isShowSponsor && sponsorData?.length > 0 && (
                    <div style={{ width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', marginTop: `${6 * px}px`, padding: `${2 * px}px`, background: 'rgba(0,0,0,0.5)', borderRadius: `${2 * px}px`, flexWrap: 'wrap', borderTop: `1px solid rgba(0,229,255,0.3)`, borderBottom: `1px solid rgba(0,229,255,0.3)`, boxShadow: `0 0 15px rgba(0,229,255,0.05)` }}>
                        {sponsorData?.slice(0, 10)?.map((i, idx) => <Image key={idx} src={i.logo || config.logo} style={{ height: `${px * 5}px`, width: 'auto', objectFit: 'contain', margin: `0 ${px}px` }} />)}
                    </div>
                )}

                {/* Footer */}
                <p style={{ textAlign: 'center', color: 'rgba(255,255,255,0.5)', fontSize: `${2 * px}px`, position: 'absolute', bottom: `${px * 1.5}px`, right: `${1.5 * px}px`, fontWeight: 'bold', letterSpacing: '2px' }}>{window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}</p>
            </div>
        </div>
    )
}

const Item = React.memo(
    ({ data, px, classCustom, idx, width, color }) => {
        const { t } = useTranslation()
        const arrRankName = ['first', 'second', 'third', 'fourth', 'fifth', 'sixth', 'seventh', 'eighth', 'ninth', 'tenth']
        let teamHomeRankName = arrRankName.includes?.(data.homeTeam?.rankName) ? `${t(data.homeTeam?.rankName)}` : ''
        let teamAwayRankName = arrRankName.includes?.(data.awayTeam?.rankName) ? `${t(data.awayTeam?.rankName)}` : ''

        const arrName = ['Winquarterfinals_1', 'Winquarterfinals_2', 'Winquarterfinals_3', 'Winquarterfinals_4', 'Losesemifinal_1', 'Losesemifinal_2', 'Winsemifinal_1', 'Winsemifinal_2', 'UnknownName']

        let teamHomeName = arrName.includes(data.homeTeam?.name) || !data.homeTeam?.id ? `${t(data.homeTeam?.name) || data.homeTeam?.name}` : data.homeTeam?.name
        let teamAwayName = arrName.includes(data.awayTeam?.name) || !data.awayTeam?.id ? `${t(data.awayTeam?.name) || data.awayTeam?.name}` : data.awayTeam?.name

        let homeName = data?.homeTeam?.id ? teamHomeName : `${teamHomeRankName} ${teamHomeName}`
        let awayName = data.awayTeam?.id ? teamAwayName : `${teamAwayRankName} ${teamAwayName}`

        return (
            <div style={{ width: `calc(50% - ${px}px)`, background: 'rgba(10, 20, 35, 0.8)', border: `1px solid rgba(0, 229, 255, 0.4)`, borderRadius: `${2 * px}px`, padding: `${2 * px}px`, display: 'flex', flexDirection: 'column', position: 'relative', boxShadow: `0 0 20px rgba(0, 229, 255, 0.1), inset 0 0 15px rgba(0, 229, 255, 0.05)`, marginBottom: `${px}px` }}>

                {/* Top bar with Stadium and Date */}
                <div style={{ display: 'flex', justifyContent: 'space-between', borderBottom: `1px dashed rgba(255,255,255,0.2)`, paddingBottom: `${px}px`, marginBottom: `${px * 1.5}px` }}>
                    <span style={{ color: color.first, fontSize: `${1.5 * px}px`, textTransform: 'uppercase', letterSpacing: '1px' }}>{data?.stadium ? data?.stadium : 'ARENA TBA'}</span>
                    <span style={{ color: color.text, fontSize: `${1.5 * px}px`, opacity: 0.8 }}>{formatDateTime(data?.dateTime, 'date')}</span>
                </div>

                <div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
                    {/* Home Team */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Image src={data?.homeTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, objectFit: 'contain', padding: `${px * 0.4}px`, backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '50%', border: `1px solid rgba(255,255,255,0.3)` }} />
                        <Name propClass={`home${data?.homeTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={homeName} px={px} color={color.text} />
                    </div>

                    {/* Time/Score */}
                    {data?.isCompleted ? (
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', margin: `0 ${px}px` }}>
                            <div style={{ background: `rgba(0,0,0,0.5)`, borderRadius: `${px}px`, padding: `${px}px ${px * 1.5}px`, border: `1px solid ${color.first}`, color: color.text, fontSize: `${3.5 * px}px`, letterSpacing: '2px', marginBottom: `${px}px`, minWidth: `${px * 16}px`, textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 10px ${color.first}`, whiteSpace: 'nowrap' }}>
                                {!data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `${data?.homeTeam?.score} - ${data?.awayTeam?.score}`}
                                {data?.homeTeam?.isGiveUp && !data?.awayTeam?.isGiveUp && `0 - ${data?.awayTeam?.giveUpScore}`}
                                {!data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `${data?.homeTeam?.giveUpScore} - 0`}
                                {data?.homeTeam?.isGiveUp && data?.awayTeam?.isGiveUp && `-`}
                            </div>
                            <div style={{ color: color.first, fontSize: `${1.6 * px}px`, textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }}>
                                FT
                            </div>
                            {data?.hasPenalty && (
                                <div style={{ color: color.third, fontSize: `${1.4 * px}px`, marginTop: `${px * 0.5}px` }}>
                                    (PEN: {data?.homeTeam?.penaltyScore} - {data?.awayTeam?.penaltyScore})
                                </div>
                            )}
                        </div>
                    ) : (
                        <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', margin: `0 ${px}px` }}>
                            <div style={{ color: color.first, fontSize: `${3.5 * px}px`, letterSpacing: '1px', marginBottom: `${px * 0.5}px`, textAlign: 'center', fontWeight: 'bold', textShadow: `0 0 10px ${color.first}` }}>
                                {formatDateTime(data?.dateTime, 'time')}
                            </div>
                            <div style={{ color: 'rgba(255,255,255,0.6)', fontSize: `${1.8 * px}px`, textTransform: 'uppercase', textAlign: 'center', fontWeight: 'bold' }}>
                                UPCOMING
                            </div>
                        </div>
                    )}

                    {/* Away Team */}
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                        <Image src={data?.awayTeam?.logo} style={{ width: `${px * 7}px`, height: `${px * 7}px`, objectFit: 'contain', padding: `${px * 0.4}px`, backgroundColor: 'rgba(255,255,255,0.1)', borderRadius: '50%', border: `1px solid rgba(255,255,255,0.3)` }} />
                        <Name propClass={`away${data?.awayTeam?.id}${new Date().getTime()}${classCustom}${idx}`} name={awayName} px={px} color={color.text} />
                    </div>
                </div>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.data) === JSON.stringify(n.data)
)

const Name = React.memo(
    ({ name, px, propClass, color }) => {
        const reSizeBasedOnWidth = () => {
            let fontSize = window && window?.getComputedStyle(document.querySelector(`.${propClass}`))?.fontSize
            if (fontSize) {
                document.querySelector(`.${propClass}`).style.fontSize = parseFloat(fontSize) - 0.2 * px + 'px'
                if (document.querySelector(`.${propClass}`).clientHeight >= document.querySelector(`.contain${propClass}`).clientHeight) {
                    reSizeBasedOnWidth()
                }
            }
        }
        const processInput = () => {
            if (document.querySelector(`.${propClass}`)) {
                document.querySelector(`.${propClass}`).innerHTML = name
                document.querySelector(`.${propClass}`).style.fontSize = px * 2.2 + 'px' // Default font size
                reSizeBasedOnWidth()
            }
        }

        React.useEffect(() => {
            processInput()
        }, [name])

        return (
            <div className={`contain${propClass}`} style={{ marginTop: `${px}px`, width: '100%', height: `${3.5 * px}px`, display: 'flex', justifyContent: 'center', alignItems: 'center', overflow: 'hidden' }}>
                <h2 className={propClass} style={{ color: color, textAlign: 'center', textTransform: 'uppercase', margin: 0, fontWeight: 'bold' }}></h2>
            </div>
        )
    },
    (p, n) => JSON.stringify(p.name) === JSON.stringify(n.name)
)

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

function areEqual(p, n) {
    return JSON.stringify(p.dataSchedules) === JSON.stringify(n.dataSchedules) && JSON.stringify(p.isShowSponsor) === JSON.stringify(n.isShowSponsor) && JSON.stringify(p.sponsorData) === JSON.stringify(n.sponsorData)
}

export default React.memo(Mau7, areEqual)
